export default class AppButton {
    isLoadingSuccess(val){
        return val ? "button is-success is-loading is-small" : "button is-success is-small"
    }

    isLoadingDanger(val){
        return val ? "button is-danger is-loading is-small" : "button is-danger is-small"
    }

    isLoadingNormal(val){
        return val ? "button is-loading is-small" : "button is-small"
    }

    isLoadingInfo(val){
        return val ? "button is-info is-loading is-small" : "button is-info is-small"
    }

    isLoadingWarning(val){
        return val ? "button is-warning is-loading is-small" : "button is-warning is-small"
    }
}